// assets/live-view-counter.js

class LiveView extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.initialContent = this.textContent; // Store initial content to avoid flickering
  }

  // Called when the element is added to the DOM
  connectedCallback() {
    // Parse data attributes, providing fallbacks
    this.min = parseInt(this.dataset.min || '5', 10);
    this.max = parseInt(this.dataset.max || '50', 10);
    // Convert interval from seconds to milliseconds
    this.interval = parseInt(this.dataset.interval || '10', 30) * 1000;
    this.messageTemplate = this.dataset.message || '[count] people are viewing this right now';

    // Ensure min is not greater than max
    if (this.min > this.max) {
      [this.min, this.max] = [this.max, this.min]; // Swap them if out of order
    }

    // Immediately update the view
    this.updateLiveView();

    // Set up interval for periodic updates
    this.intervalId = setInterval(() => this.updateLiveView(), this.interval);
  }

  // Called when the element is removed from the DOM
  disconnectedCallback() {
    // Clear the interval to prevent memory leaks
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  // Generates a random count and updates the element's text content
  updateLiveView() {
    const count = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.textContent = this.messageTemplate.replace('[count]', count);
  }
}

// Define the custom element 'live-view'
// Check if it's already defined to prevent errors if the script runs multiple times
if (!customElements.get('live-view')) {
  customElements.define('live-view', LiveView);
}